// aws-amplify v6: a single GraphQL client, replacing the v5 `API.graphql(graphqlOperation(...))`.
// All Pawtect data calls are public (API key); the data API's default auth mode is apiKey.
import { generateClient } from 'aws-amplify/api';

export const client = generateClient();
